import React from "react";
import { useLocation } from "react-router-dom";
import VendorBreadcrumbs from "./VendorBreadcrumbs";
import GenericBreadcrumbs from "./Breadcrumbs";

const BreadcrumbsSwitcher = () => {
  const location = useLocation();
  const segments = location.pathname.split("/").filter(Boolean);

  // If on a vendor subpage, use VendorBreadcrumbs
  if (
    segments.length >= 3 &&
    segments[0] === "sales" &&
    segments[1] === "vendors"
  ) {
    return <VendorBreadcrumbs />;
  }
  // Otherwise, use generic
  return <GenericBreadcrumbs />;
};

export default BreadcrumbsSwitcher;
